import { render, staticRenderFns } from "./activitiesDetail2021ty.vue?vue&type=template&id=8ca5cc32&scoped=true"
import script from "./activitiesDetail2021ty.vue?vue&type=script&lang=js"
export * from "./activitiesDetail2021ty.vue?vue&type=script&lang=js"
import style0 from "./activitiesDetail2021ty.vue?vue&type=style&index=0&id=8ca5cc32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca5cc32",
  null
  
)

export default component.exports